export default __webpack_public_path__ + "static/media/S0020_6.6_METHANE.1702919100000.e8514a38.jpg";